import React, { useState, useEffect } from 'react';
import { useLanguage } from '../../../contexts/LanguageContext';
import Sidebar from '../../Layout/Sidebar';
import LanguageSelector from '../../Layout/LanguageSelector';
import CleaningRequest from './CleaningRequest';
import ActiveJobs from './ActiveJobs';
import ClientArchives from './ClientArchives';
import NotificationsPanel from '../NotificationsPanel';
import ChatPanel from '../ChatPanel';
import Profile from '../Profile';
import api from '../../../utils/api';
import './ClientDashboard.css';

const ClientDashboard = () => {
  const { t } = useLanguage();
  const [activeTab, setActiveTab] = useState('pending');
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [notifUnread, setNotifUnread] = useState(0);
  const [chatUnread, setChatUnread] = useState(0);

  useEffect(() => {
    const pollBadges = async () => {
      try {
        const [notifRes, chatRes] = await Promise.all([
          api.get('/notifications/unread-count'),
          api.get('/chat/unread-count')
        ]);
        if (notifRes.data?.data?.count !== undefined) setNotifUnread(notifRes.data.data.count);
        if (chatRes.data?.data?.count !== undefined) setChatUnread(chatRes.data.data.count);
      } catch { /* silent */ }
    };
    pollBadges();
    const interval = setInterval(pollBadges, 30000);
    return () => clearInterval(interval);
  }, []);
  const userId = localStorage.getItem('userId') || 'client-001';

  useEffect(() => {
    // Ensure userId is set
    if (!localStorage.getItem('userId')) {
      localStorage.setItem('userId', 'client-001');
    }
  }, []);

  const menuItems = [
    {
      label: t('dashboard.newRequest', 'New Request'),
      icon: '➕',
      path: '/client',
      active: activeTab === 'request',
      onClick: () => setActiveTab('request')
    },
    {
      label: t('dashboard.pending', 'Pending'),
      icon: '⏳',
      path: '/client',
      active: activeTab === 'pending',
      onClick: () => setActiveTab('pending')
    },
    {
      label: t('dashboard.approved', 'Approved'),
      icon: '✅',
      path: '/client',
      active: activeTab === 'approved',
      onClick: () => setActiveTab('approved')
    },
    {
      label: t('dashboard.archives', 'Archives'),
      icon: '📁',
      path: '/client',
      active: activeTab === 'archives',
      onClick: () => setActiveTab('archives')
    },
    {
      label: t('dashboard.notifications', 'Notifications'),
      icon: '🔔',
      path: '/client',
      active: activeTab === 'notifications',
      onClick: () => setActiveTab('notifications'),
      badge: notifUnread
    },
    {
      label: t('dashboard.chat', 'Chat'),
      icon: '💬',
      path: '/client',
      active: activeTab === 'chat',
      onClick: () => setActiveTab('chat'),
      badge: chatUnread
    },
    {
      label: t('dashboard.profile', 'Profile'),
      icon: '👤',
      path: '/client',
      active: activeTab === 'profile',
      onClick: () => setActiveTab('profile')
    }
  ];

  return (
    <div className="client-dashboard">
      <Sidebar 
        menuItems={menuItems} 
        userRole="client" 
        isOpen={sidebarOpen}
        onClose={() => setSidebarOpen(false)}
      />
      <div className="dashboard-main">
        <div className="mobile-header">
          <button 
            className="mobile-menu-btn"
            onClick={() => setSidebarOpen(!sidebarOpen)}
            aria-label="Toggle menu"
          >
            <span className="hamburger-icon">☰</span>
          </button>
          <h1 className="mobile-title">{t('dashboard.clientDashboard', 'Client Dashboard')}</h1>
          <div className="header-language-selector">
            <LanguageSelector />
          </div>
        </div>
        <div className="dashboard-container">
          <div className="dashboard-header-wrapper">
            <h1 className="desktop-title">{t('dashboard.clientDashboard', 'Client Dashboard')}</h1>
            <div className="header-language-selector desktop-only">
              <LanguageSelector />
            </div>
          </div>
          
          <div className="dashboard-content">
            {activeTab === 'pending' && <ActiveJobs userId={userId} statusFilter="pending" />}
            {activeTab === 'approved' && <ActiveJobs userId={userId} statusFilter="approved" />}
            {activeTab === 'request' && <CleaningRequest userId={userId} />}
            {activeTab === 'archives' && <ClientArchives userId={userId} />}
            {activeTab === 'notifications' && <NotificationsPanel onUnreadCountChange={setNotifUnread} />}
            {activeTab === 'chat' && <ChatPanel onUnreadCountChange={setChatUnread} />}
            {activeTab === 'profile' && <Profile userRole="client" />}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ClientDashboard;



